import { StandardComp } from "../atoms/standardComp"
import { RapportKpiComp } from "../components/kpiComp"
import { GraphComp } from "../components/graphComp"
import { getAPI, postAPI, updateAPI } from "../api/api"
import { useContext, useEffect, useState } from "react"
import { ToastContext } from "../App"

export function ReportsOverview({ courses, selectedCourses }) {
  const [reportKPI, setReportKPI] = useState([{ id_report: 1, name: "Voeg kpi toe", total_metric: "" }])
  const [period, setPeriod] = useState(6)
  const [activeGraph, setActiveGraph] = useState(0)
  const [graphData, setGraphData] = useState([])
  const [activeKPI, setActiveKPI] = useState(0)
  const [reportOptions, setReportOptions] = useState([{ pretty_name: "", id_report: 1 }])
  const toastContext = useContext(ToastContext)

  const loadReports = async () => {
    console.log("selected courses: ", selectedCourses)
    const query = `api/reports/reports?courses=[${selectedCourses}]`
    const reports = await getAPI(query)
    console.log(reports.data)
    if (reports.data.length == 0) {
      return
    }
    setReportKPI(reports.data)
  }

  const loadGraph = async (report, period) => {
    if (selectedCourses.length > 0) {
      const query = `api/reports/reports/graph?id_report=${report?.id_report}&period=${period}&courses=${selectedCourses}`
      const graph = await getAPI(query)
      setGraphData(graph.data.dataset)
    }


  }
  const loadReportOptions = async () => {
    const query = `api/reports/reports/options/available`
    const option = await getAPI(query)
    setReportOptions(option.data)
  }
  const handleActiveGraph = (index) => {
    setActiveGraph(index)
    loadGraph(reportKPI[index], period)

  }
  useEffect(() => {
    loadReports()
    loadReportOptions()
    loadGraph(reportKPI[activeKPI],period)
  }, [selectedCourses])

  const swap = async (id, index) => {
    console.log(reportKPI[index], index)
    const query = "api/reports/reports/update"
    const body = { "id_report": id, "old_id_report": reportKPI[index].id_report, period: period, order: index }
    console.log("new_body", body)
    await updateAPI(query, body)
  }

  const add = async (id, index) => {
    if (reportKPI.length >= 4) {
      return toastContext.showToast("Je kan maximaal 4 KPI's toevoegen aan je overzicht", "error")
    }
    const query = "api/reports/reports/add"
    const body = { "id_report": id, period: period, order: index }
    console.log("new_body", body)
    await postAPI(query, body)
    await loadReports()
    await loadReportOptions()
  }

  const completeSwap = async (id, index) => {
    await swap(id, index)
    await loadReports()
    await loadReportOptions()
  }
  const reloadPeriod = async (id) => {
    setPeriod(id)
    await loadGraph(reportKPI[activeGraph], id)
  }
  return (
    <StandardComp
      editClass={"standard-margin phone-reports-stats no-padding"}
      content={
        <div className={"horizontal phone-reports-stats"} style={{ alignItems: "stretch" }}>
          <div className={"vertical stats-grid"} style={{ width: "40%" }}>
            {reportKPI.map((row, index) => {
              return (
                <RapportKpiComp
                  editClass={"no-margin no-rounded standard-border-top rapport-kpi-comp"}
                  style={{ paddingRight: "1rem" }}
                  key={row.order}
                  title={row.name}
                  value={row.total_metric || 0}
                  percentage={row.difference_status}
                  icon2={row.metric_icon}
                  dropdownOptions={reportOptions.map((report) => ({
                    id: report.id_report,
                    content: report.pretty_name
                  }))}
                  onSelectDropdown={(id) => completeSwap(id, index)}
                  onToggleGraph={() => handleActiveGraph(index)}
                  isActive={activeGraph === index}
                  unit={row.unit}
                />
              );
            })}
            {(reportKPI.length < 4 && reportKPI.length > 0) &&
              <RapportKpiComp
                editClass={"no-margin no-rounded standard-border-top rapport-kpi-comp"}
                style={{ paddingRight: "1rem" }}
                key={reportKPI.length}
                title={"Voeg KPI toe"}
                value={""}
                percentage={0}
                icon2={''}
                dropdownOptions={reportOptions.map((report) => ({
                  id: report.id_report,
                  content: report.pretty_name
                }))}
                onSelectDropdown={(id) => add(id, reportKPI.length)}
                onToggleGraph={() => { }}
                isActive={activeGraph === 0}
                unit={'leeg'}
              />
            }
          </div>
          <div
            className={"standard-padding standard-border-left reports-graph"}
            style={{ alignContent: "center", width: "calc(100% - 40%)", height: "unset" }}
          >
            <GraphComp setPeriod={reloadPeriod} period={period} dataset={{ graph: graphData.map((row) => row["total_metric"]), courses: courses.filter(course => selectedCourses.includes(course.id_course)) }} graph={"rapport"} title={reportKPI[activeGraph].name} />
          </div>
        </div>
      }
    />
  );
}
